<template>
    <div>
        <!--Navigation Drawer-->
        <v-navigation-drawer
                fixed
                :clipped="$vuetify.breakpoint.mdAndUp"
                app
                v-model="drawer"
                :enable-resize-watcher="drawer"
                class="navDrawer"
        >
            <!-- List of items in Nav Drawer -->
            <v-list dense class="primary--text">
                <template v-for="(item, i) in menuItems">
                    <!-- Items with title witch are not expanding -->
                    <v-list-item
                      :key="i"
                      v-if="item.title && permissions.includes(item.name)"
                      router
                      :to="item.link"
                    >
                        <v-list-item-action>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ item.title }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      :key="i"
                      v-else-if="item.title && !permissions.includes(item.name)"
                      @click="$root.$emit('PermissionDialog', item.title)"
                    >
                        <v-list-item-action>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ item.title }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <!-- Expanding main group section -->
                    <v-list-group
                            :key="i"
                            v-else-if="item.title_expand"
                    >
                        <!-- Main title -->
                        <v-list-item slot="activator">
                            <v-list-item-action>
                                <v-icon>{{item.icon}}</v-icon>
                            </v-list-item-action>
                            <v-list-item-title>{{item.title_expand}}</v-list-item-title>
                        </v-list-item>
                        <!-- subtitlesSectionOne -->
                        <template v-for="(item, i) in item.subtitlesSectionOne">
                            <v-list-item
                            v-if="permissions.includes(item[2])"
                            :key="i"
                            router
                            :to="item[1]"
                            >
                                <v-list-item-action>
                                    <v-icon>{{item.icon}}</v-icon>
                                </v-list-item-action>
                                <v-list-item-title
                                        v-text="item[0]"
                                        :class="item.length < 2  ?  'menu-link-disabled':''"
                                >
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                            v-else
                            :key="i"
                            @click="$root.$emit('PermissionDialog', item[0])"
                            >
                                <v-list-item-action>
                                    <v-icon>{{item.icon}}</v-icon>
                                </v-list-item-action>
                                <v-list-item-title
                                        v-text="item[0]"
                                        :class="item.length < 2  ?  'menu-link-disabled':''"
                                >
                                </v-list-item-title>
                            </v-list-item>
                        </template>
                        <!-- Sub Expanding group 1-->
                        <v-list-group
                                sub-group
                                no-action
                                v-if="item.sub_group_one_children"
                                class="subGroupOne"
                        >
                            <!-- Title -->
                            <v-list-item
                                    slot="activator"
                                    class="subGroupTitle"
                            >
                                <v-list-item-title>{{item.sub_group_one_title}}</v-list-item-title>
                            </v-list-item>
                            <!-- Item title -->
                            <v-list-item
                                    v-for="(item, i) in item.sub_group_one_children"
                                    :key="i"
                                    router
                                    :to="item[1]"
                                    class="subGroupChildren"
                            >
                                <v-list-item-title
                                        v-text="item[0]"
                                        :class="item.length < 2  ?  'menu-link-disabled':''"
                                >
                                </v-list-item-title>
                            </v-list-item>
                        </v-list-group>
                        <!-- subtitlesSectionOne Two -->
                        <v-list-item
                                v-for="(item, i) in item.subtitlesSectionTwo"
                                :key="i"
                                router
                                :to="item[1]"
                        >
                            <v-list-item-action>
                                <v-icon>{{item.icon}}</v-icon>
                            </v-list-item-action>
                            <v-list-item-title
                                    v-text="item[0]"
                                    :class="item.length < 2  ?  'menu-link-disabled':''"
                            >
                            </v-list-item-title>
                        </v-list-item>
                        <!-- Sub Expanding group 2-->
                        <v-list-group
                                sub-group
                                no-action
                                v-if="item.sub_group2_children"
                        >
                            <!-- Title -->
                            <v-list-item
                                    slot="activator"
                                    class="subGroupTitle"
                            >
                                <v-list-item-title>{{item.sub_group2_title}}</v-list-item-title>
                            </v-list-item>
                            <!-- Item title -->
                            <v-list-item
                                    v-for="(item, i) in item.sub_group2_children"
                                    :key="i"
                                    router
                                    :to="item[1]"
                            >
                                <v-list-item-title
                                        v-text="item[0]"
                                        :class="item.length < 2  ?  'menu-link-disabled':''"
                                >
                                </v-list-item-title>
                            </v-list-item>
                        </v-list-group>
                        <v-list-group
                          sub-group
                          no-action
                          v-if="item.sub_group3_children"
                        >
                            <!-- Title -->
                            <v-list-item
                              slot="activator"
                              class="subGroupTitle"
                            >
                                <v-list-item-title>{{item.sub_group3_title}}</v-list-item-title>
                            </v-list-item>
                            <!-- Item title -->
                            <v-list-item
                              v-for="(item, i) in item.sub_group3_children"
                              :key="i"
                              router
                              :to="item[1]"
                            >
                                <v-list-item-title
                                  v-text="item[0]"
                                  :class="item.length < 2  ?  'menu-link-disabled':''"
                                >
                                </v-list-item-title>
                            </v-list-item>
                        </v-list-group>
                    </v-list-group>
                </template>
            </v-list>
        </v-navigation-drawer>
        <!-- Toolbar     -->
        <v-app-bar
          id="toolbar"
          :class="organizationView ? 'primary' : 'grey lighten-3'"
          :dark="organizationView"
          app
          :clipped-left="$vuetify.breakpoint.mdAndUp"
          fixed
          extension-height="48px"
        >
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
            <router-link v-if="!organizationView" to="/" style="cursor:pointer">
                <img id="logo-portal" :src="logo_icon" style="vertical-align: text-bottom;"/>
            </router-link>
            <v-toolbar-title v-else>Advertiser<span> - {{decodeURIComponent($route.params.organization_name)}}</span></v-toolbar-title>
            <!-- <v-text-field
              v-if="!organizationView && $vuetify.breakpoint.smAndUp"
              solo-inverted
              flat
              hide-details
              label="Search"
              prepend-inner-icon="mdi-magnify"
              class="ml-3"
            /> -->
            <v-spacer></v-spacer>
            <v-toolbar-items v-if="!organizationView" class="toolbar-items">
              <v-layout class="row align-center fill-height mr-1">
                <v-toolbar-title class="gray--text" style="font-size: 12px; font-weight: normal; padding-left: 5px; padding-right: 5px;">{{ `v${version}` }}</v-toolbar-title>
                <!-- <v-btn icon class="toolbar-icons" @click="markAsReadNotifications()">
                    <v-badge top color="red" :overlap="true">
                        <template slot="badge" v-if="notificationShow">
                            <span small style="font-size: 12px;">{{new_notifications > 9 ? '9+' : new_notifications}}</span>
                        </template>
                        <v-icon>mdi-bell</v-icon>
                    </v-badge>
                </v-btn> -->
                <v-menu light offset-y bottom left content-class="fixed-meny">  
                    <template v-slot:activator="{ on }">
                        <v-avatar size="30" color="primary" class="toolbar-icons pointer ml-1">
                          <img v-on="on" v-if="!no_data.includes(user) && !no_data.includes(user.avatar)" :src="user.avatar">
                          <span v-on="on" class="title" style="color: #fff;">{{ user.first_name.charAt(0)}}</span>
                        </v-avatar>
                    </template>
                    <v-card three-line style="width: 300px;">
                        <v-list class="py-0">
                            <div @click.stop="" class="py-2">
                            <v-list-item>
                                <v-avatar color="primary mr-2">
                                    <img v-if="!no_data.includes(user) && !no_data.includes(user.avatar)" :src="user.avatar">
                                    <span v-else class="headline white--text" style="color: #fff;">{{ user.first_name.charAt(0)}}</span>
                                </v-avatar>

                                <v-list-item-content>
                                    <template v-if="user.role === 'admin'">
                                        <v-list-item-title>{{ `${user.first_name} ${user.last_name}` }}</v-list-item-title>
                                        <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
                                    </template>
                                    <template v-else>
                                        <v-list-item-title>{{ `${user.first_name} ${user.last_name}` }}</v-list-item-title>
                                        <v-list-item-subtitle>{{ user.organization_name }}</v-list-item-subtitle>
                                    </template>
                                </v-list-item-content>
                            </v-list-item>
                            </div>
                        </v-list>
                        <v-divider></v-divider>
                        <v-list>
                            <v-list-item
                                v-if="this.permissions.includes('change_password')"
                                @click="$router.push('/change_password')"
                            >
                                <v-list-item-title style="font-size: 13px;">Change Password</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                v-if="this.permissions.includes('change_email')"
                                @click="$router.push('/change_email')"
                            >
                                <v-list-item-title style="font-size: 13px;">Change Email</v-list-item-title>
                            </v-list-item>
                            <!-- <v-list-item
                                v-if="this.permissions.includes('two_factor')"
                                @click="$router.push('/two_factor')"
                            >
                                <v-list-item-title style="font-size: 13px;">Two-Factor Authentication</v-list-item-title>
                                <v-list-item-action v-if="Number(two_factor_enabled) === 1" style="justify-content: flex-end;"><v-icon color="success">done</v-icon></v-list-item-action>
                            </v-list-item> -->
                            <v-divider></v-divider>
                            <v-list-item
                                @click="logout"
                                color="primary"
                            >
                                <v-list-item-title class="text-uppercase" style="font-size: 14px;">Logout</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-menu>

                </v-layout>
            </v-toolbar-items>
            <v-toolbar-items v-else class="toolbar-items">
                <v-layout class="row align-center fill-height mr-1">
                    <v-btn v-if="organizationView" icon dark @click="closeOrganizationView">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-layout>
            </v-toolbar-items>
            <!-- <v-layout v-if="!isSubscribed && this.permissions.includes('subscription_details')" slot="extension" style="background: #f4f4f4; color: black;">
                <SubscribeNow></SubscribeNow>
            </v-layout> -->
        </v-app-bar>
        <v-content>
            <notification-message></notification-message>
            <v-container id="main-content" fluid fill-height>
                <v-layout justify-center align-center>
                    <main role="main" class="container xs-no-padding">
                        <router-view :key="$route.path"></router-view>
                    </main>
                </v-layout>
                <light-box></light-box>
                <permission-dialog></permission-dialog>
                <!-- <plan-status></plan-status> -->
            </v-container>
        <!-- <Footer></Footer> -->
        </v-content>
    </div>
</template>


<script>
    import NotificationMessage from './NotificationMessage'
    import LightBox from './LightBox'
    import PermissionDialog from './PermissionDialog'
    import {LOGOUT} from "@/store/actions.type"
    import {mapGetters, mapState} from "vuex"

    export default {
        name: 'UserLayout',
        data: () => ({
            no_data: [null, '', undefined, 'null'],
            dialog: false,
            logo_icon: require('@/assets/img/logo/CD_logo.svg'),
            drawer: '',
            loading: true,
            new_messages: 0,
            new_notifications: 0,
            notificationShow: false,
            messageShow: false,
            permissionDialog: false,
            perrmissionText: '',
            userItems: [
                {icon: 'mdi-view-dashboard', title: 'Dashboard', link: '/', name: 'dashboard'},
                {
                    icon: 'mdi-alpha-a-box-outline', title_expand: 'Advertising Analytics',
                    subtitlesSectionOne: [
                        ['Web Ads', '/web_ads', 'web_ads'],
                        ['Print/Digital Ads', '/print_digital_ads', 'print_digital_ads'],
                        ['Newsletter', '/newsletter', 'newsletter'],
                    ]
                },
                {icon: 'mdi-television-guide', title: 'Product Guide', link: '/product_guide', name: "product_guide"},
                {icon: 'mdi-cast-education', title: 'Trainings', link: '/trainings', name: 'trainings'},
                {icon: 'mdi-chart-bell-curve-cumulative', title: 'Reports', link: '/reports', name: 'reports'},
                {icon: 'mdi-credit-card-multiple', title: 'Credit Cards', link: '/credit_cards', name: 'credit_cards'},
                {icon: 'mdi-badge-account-horizontal-outline', title: 'Company Profiles', link: '/company_profiles', name: 'company_profiles'},
            ],
            adminItems: [
                {icon: 'mdi-view-dashboard', title: 'Dashboard', link: '/', name: 'dashboard'},
                {icon: 'mdi-account-group', title: 'Advertisers', link: '/advertisers', name: 'admin_advertisers'},
                {icon: 'mdi-view-list', title: 'Categories', link: '/categories', name: 'admin_categories'},
                {icon: 'mdi-package-variant-closed', title: 'Service Plans', link: '/service_plans', name: 'service_plans'},
                {icon: 'mdi-checkbook', title: 'Subscriptions', link: '/subscriptions', name: 'subscriptions'},
                {icon: 'mdi-application', title: 'Print/Digital Issues', link: '/print_digital_issues', name: 'print_digital_issues'},
                {icon: 'mdi-newspaper', title: 'Newsletters', link: '/newsletters', name: 'admin_newsletters'},
            ],
        }),
        components: {
            NotificationMessage,
            LightBox,
            PermissionDialog
        },
        beforeMount() {
            this.navDrawerMobile();
        },
        mounted() {
        },
        created() {
        },
        methods: {
            logout() {
                this.$store
                    .dispatch(LOGOUT)
                    .then(() => this.$router.push({name: "login"}));
            },
            navDrawerMobile() {
                if (window.innerWidth < 1264) {
                    this.drawer = false;
                } else {
                    this.drawer = true;
                }
            },
            closeOrganizationView () {
                this.$router.push('/advertisers')
            },
            markAsReadNotifications(){
                this.notificationShow = false;
                this.new_notifications=0;
                this.$router.push({name: "notifications"});
            }
        },
        computed: {
            ...mapGetters(["user", "subscriptionPackage", "permissions"]),
            ...mapState({
                two_factor_enabled: state => state.auth.user.two_factor,
                version: state => state.auth.version
            }),
            organizationView () {
                return this.$route.path.includes('/advertiser/')
            },
            menuItems () {
                let items = []
                if (this.user.role === 'admin') {
                    if (this.organizationView) {
                        let organization_id = this.$route.params.organization_id
                        let organization_name = this.$route.params.organization_name
                        items = [
                            {icon: 'mdi-view-dashboard', title: 'Dashboard', link: '/', name: 'dashboard'},
                            {icon: 'mdi-account-group', title: 'Advertisers', link: '/advertisers', name: 'admin_advertisers'},
                            {icon: 'mdi-card-account-details', title: 'Advertiser Details', link: `/advertiser/${organization_id}/${organization_name}/details`, name: "admin_advertiser_details"},
                            {
                                icon: 'mdi-alpha-a-box-outline', title_expand: 'Advertising Analytics',
                                subtitlesSectionOne: [
                                    ['Web Ads', `/advertiser/${organization_id}/${organization_name}/web_ads`, 'admin_web_ads'],
                                    ['Print/Digital Ads', `/advertiser/${organization_id}/${organization_name}/print_digital_ads`, 'admin_print_digital_ads'],
                                    ['Newsletter', `/advertiser/${organization_id}/${organization_name}/newsletter`, 'admin_newsletter'],
                                ]
                            },
                            {icon: 'mdi-television-guide', title: 'Product Guide', link: `/advertiser/${organization_id}/${organization_name}/product_guide`, name: "admin_product_guide"},
                            {icon: 'mdi-cast-education', title: 'Trainings', link: `/advertiser/${organization_id}/${organization_name}/trainings`, name: "admin_advertiser_details"},
                            {icon: 'mdi-credit-card-multiple', title: 'Credit Cards', link: `/advertiser/${organization_id}/${organization_name}/credit_cards`, name: "admin_credit_cards"},
                            {icon: 'mdi-chart-bell-curve-cumulative', title: 'Reports', link: `/advertiser/${organization_id}/${organization_name}/reports`, name: "admin_advertiser_details"}
                        ]
                    } else {
                        items = _.cloneDeep(this.adminItems)
                    }
                } else {
                    items = _.cloneDeep(this.userItems)
                }

                // filter permissions
                // items.forEach(i => {
                //     if (i.title_expand) {
                //         i.subtitlesSectionOne = [...i.subtitlesSectionOne.filter(s => { return this.permissions.includes(s[2])})]
                //     }
                // })
                // items = items.filter(i => {
                //     if(i.title) {
                //         return this.permissions.includes(i.link) || i.link === '/' || this.permissions.includes(i.name)
                //     } else if (i.title_expand) {
                //         return i.subtitlesSectionOne.length > 0
                //     }
                // })

                return items
            }
        }
    }
</script>

<style scoped>
    /*Logo*/
    #logo-portal{
        width: 115px;
        max-width: 115px;
        margin-left: 10px;
    }
    /*Toolbar buttons*/
    .toolbar__items {
        height: auto !important;
    }

    /**Navigation Bar Style **/

    .list--dense {
        padding-top: 17px;
    }

    .subheader {
        padding-left: 0px;
    }

    .list__tile__title.sub-text-deactive {
        padding-left: 50px;
        color: grey;
    }

    .list__tile__title.heading-active {
        padding-left: 0px;
    }

    /*If menu item view does not exists*/
    .menu-link-disabled {
        color: grey;
    }

    /*Align buttons hover*/
    toolbar__side-icon.btn.btn--icon {
        margin: -6px;
    }

    .toolbar-icons .btn__content {
        margin: 0px !important;
    }

    /*Progress bar*/
    .progress-linear {
        position: absolute;
        margin-top: 35px;
    }

    @media only screen and (max-width: 600px) {
        .xs-no-padding {
            padding: 0px 0px 32px;
        }
    }

    .v-toolbar__extension {
        background: #f5f5f5;
    }

    /* .subscription-disabled {
        color: #cdcdcd!important;
    } */

    .fixed-meny {
        position: fixed!important;
        top: 48px!important;
    }

    @media only screen and (min-width: 960px) {
        .fixed-meny {
            top: 64px!important;
        }
    }
</style>

<style>
  .v-list-group .v-list-group__header {
    padding-left: 0;
  }
</style>
